import { DEFAULT_CURRENCY } from '@features/invoices/constants/defaultCurrency'
import { DEFAULT_INVOICE_LANGUAGE } from '@features/invoices/constants/defaultInvoiceLanguage'
import { invoiceLanguageToLocale } from '@features/invoices/constants/invoiceLanguageToLocale'
import { ProductType } from '@features/products/enums/productType'

import type { PresetsSettingsFormValues } from '../../../types/presetsSettingsFormValues'

export const getPresetsSettingsDefaultValues = (
  predefinedValues?: Partial<PresetsSettingsFormValues>,
): PresetsSettingsFormValues => ({
  contactEmail: predefinedValues?.contactEmail || '',
  contactFirstName: predefinedValues?.contactFirstName || '',
  contactLastName: predefinedValues?.contactLastName || '',
  contactPhone: predefinedValues?.contactPhone || '',
  currency: predefinedValues?.currency || DEFAULT_CURRENCY,
  language: predefinedValues?.language || invoiceLanguageToLocale[DEFAULT_INVOICE_LANGUAGE],
  productType: predefinedValues?.productType || ProductType.Goods,
})
